import Image from "next/image";
import useViewport, { Viewport } from "../../hooks/useViewport";

import CollapsedQuestion from "../collapsed-question";

import styles from "./team-member.module.scss";

function TeamMember({ teamMember }) {
  const device = useViewport();

  return (
    <div className={styles.TeamMember}>
      <div className={styles.Image}>
        <Image
          src={teamMember.image.url}
          width="397"
          height="528"
          layout="responsive"
          objectFit="cover"
          alt={teamMember.name}
        />
      </div>

      {device !== Viewport.PHONE && (
        <div className={styles.MemberName}>
          <div className={styles.Name}>{teamMember.name}</div>
          <div className={styles.Name}>{teamMember.jobTitle}</div>
        </div>
      )}

      {device === Viewport.PHONE && (
        <div className={styles.MemberName}>
          <div className={styles.Name}>
            {[teamMember.name, teamMember.jobTitle].join(", ")}
          </div>
        </div>
      )}

      <div className={styles.Biography}>
        <h3>Tell us what you do?</h3>

        <p>{teamMember.biography}</p>
      </div>

      <div className={styles.FAQ}>
        {teamMember.questionsCollection.items.map((faq) => (
          <CollapsedQuestion
            key={faq.title}
            question={faq.title}
            answer={faq.description}
          />
        ))}
      </div>
    </div>
  );
}

export default TeamMember;
